import React, { useEffect, useState } from "react";
import axios from "axios";
import { Modal } from "antd";


const WorkerApplication = () => {
  const apiUrl = import.meta.env.VITE_API_URL; // API Base URL
  const [formFields, setFormFields] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [formState, setFormState] = useState({}); // State to store form data
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Fetch form fields from the API
  useEffect(() => {
    const fetchFormFields = async () => {
      try {
        const response = await axios.get(`${apiUrl}/forms/3`);
        setFormFields(response.data.fields || []);
        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching form fields:", error);
        setIsLoading(false);
      }
    };

    fetchFormFields();
  }, [apiUrl]);

  // Handle form submission

  // ...
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true); // Start loading
  
    let formData = new FormData();
    formData.append("form_id", 3);
  
    formFields.forEach((field) => {
      const fieldValue = formState[field.name];
  
      if ((field.field_type === "image" || field.field_type === "file") && formState[field.name]) {
        const file = formState[field.name][0];
        formData.append(`file_${field.id}`, file);
        formData.append(`field_${field.id}`, "");
      } else if (fieldValue || field.field_type === "checkbox" || field.field_type === "radio") {
        formData.append(`field_${field.id}`, fieldValue || "");
      }
    });
  
    try {
      const response = await axios.post(`${apiUrl}/form_responses/submit/`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
  
      Modal.success({
        title: 'Form Submitted Successfully!',
        content: 'Thank you! We have received your information.',
        onOk: () => window.location.reload(),
      });
  
    } catch (error) {
      console.error("Error submitting form:", error);
      Modal.error({
        title: 'Submission Failed',
        content: 'Please try again. Something went wrong.',
      });
    } finally {
      setIsSubmitting(false); // Stop loading
    }
  };
  
  
  
  
  
  

  // // Submit the form data after conversion
  // const submitFormData = async (formData) => {
  //   try {
  //     const response = await axios.post(`${apiUrl}/form_responses/submit/`, formData, {
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //     });
  //     console.log("Form submitted successfully:", response.data);
  //     alert("Form submitted successfully!");
  //   } catch (error) {
  //     console.error("Error submitting form:", error);
  //     alert("Error submitting form. Please try again.");
  //   }
  // };

  // Handle change for form inputs
  const handleInputChange = (e) => {
    const { name, value, type, files, checked } = e.target;
    if (type === "checkbox") {
      setFormState((prev) => ({
        ...prev,
        [name]: prev[name]
          ? checked
            ? [...prev[name], value]
            : prev[name].filter((v) => v !== value)
          : checked
          ? [value]
          : [],
      }));
    } else if (type === "radio") {
      setFormState((prev) => ({ ...prev, [name]: value }));
    } else if (type === "file") {
      setFormState((prev) => ({ ...prev, [name]: files }));
    } else {
      setFormState((prev) => ({ ...prev, [name]: value }));
    }
  };

  return (
    <div className="bg-black lg:min-h-screen flex items-center justify-center px-5 py-10">
      <div className="bg-white shadow-lg rounded-lg max-w-4xl w-full p-8 border-t-8 border-[#e6b800]">
        <h2 className="text-3xl font-bold text-center text-black mb-6">
        Demand Submission Form
        </h2>
        <p className="text-center text-gray-700 mb-8">
        Submit your worker demand requirements below. We’ll get in touch promptly to discuss your needs.
        
            </p>

        {isLoading ? (
          <p className="text-center text-gray-700">Loading form fields...</p>
        ) : (
          <form className="space-y-6" onSubmit={handleSubmit}>
            {formFields.map((field, index) => (
              <div key={index}>
                <label
                  className="block text-black font-medium mb-2"
                  htmlFor={field.name}
                >
                  {field.name}
                  {field.required && <span className="text-red-500"> *</span>}
                </label>

                {/* Handle text and email fields */}
                {field.field_type === "text" && (
                  <input
                    type="text"
                    name={field.name}
                    id={field.name}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#e6b800]"
                    placeholder={`Enter your ${field.name}`}
                    required={field.required}
                    value={formState[field.name] || ""}
                    onChange={handleInputChange}
                  />
                )}
                {field.field_type === "email" && (
                  <input
                    type="email"
                    name={field.name}
                    id={field.name}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#e6b800]"
                    placeholder={`Enter your ${field.name}`}
                    required={field.required}
                    value={formState[field.name] || ""}
                    onChange={handleInputChange}
                  />
                )}

                {/* Handle phone number input */}
                {field.field_type === "phone" && (
                  <input
                    type="tel"
                    name={field.name}
                    id={field.name}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#e6b800]"
                    placeholder={`Enter your ${field.name}`}
                    required={field.required}
                    value={formState[field.name] || ""}
                    onChange={handleInputChange}
                  />
                )}

                {/* Handle image upload (file input) */}
                {(field.field_type === "image" || field.field_type === "file") && (
                  <input
                    type="file"
                    name={field.name}
                    id={field.name}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#e6b800]"
                    required={field.required}
                    onChange={handleInputChange}
                  />
                )}

                {/* Handle text area */}
                {field.field_type === "textarea" && (
                  <textarea
                    name={field.name}
                    id={field.name}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#e6b800]"
                    placeholder={`Enter your ${field.name}`}
                    rows="3"
                    required={field.required}
                    value={formState[field.name] || ""}
                    onChange={handleInputChange}
                  ></textarea>
                )}

                {/* Handle choice (checkbox) */}
                {field.field_type === "checkbox" && (
                  <div className="flex flex-wrap  items-center gap-10 justify-center ">
                    {field.options &&
                      field.options.map((option, i) => (
                        <label key={i} className="flex items-center ">
                          <input
                            type="checkbox"
                            name={field.name}
                            value={option}
                            checked={formState[field.name]?.includes(option)}
                            onChange={handleInputChange}
                            className="text-[#e6b800] border-gray-300 rounded focus:ring-2 focus:ring-[#e6b800]"
                          />
                          <span className="text-gray-700 focus:bg-alf" >{option}</span>
                        </label>
                      ))}
                  </div>
                )}

                {/* Handle choice (radio) */}
                {field.field_type === "radio" && (
                  <div className="space-y-2">
                    {field.options &&
                      field.options.map((option, i) => (
                        <label key={i} className="flex items-center space-x-2">
                          <input
                            type="radio"
                            name={field.name}
                            value={option}
                            checked={formState[field.name] === option}
                            onChange={handleInputChange}
                            className="text-[#e6b800] border-gray-300  focus:ring-2 focus:ring-[#e6b800]"
                          />
                          <span className="text-gray-700">{option}</span>
                        </label>
                      ))}
                  </div>
                )}

                {/* Handle select dropdown */}
                {field.field_type === "select" && (
                  <select
                    name={field.name}
                    id={field.name}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#e6b800]"
                    required={field.required}
                    value={formState[field.name] || ""}
                    onChange={handleInputChange}
                  >
                    <option value="">Select {field.name}</option>
                    {field.options &&
                      field.options.map((option, i) => (
                        <option key={i} value={option}>
                          {option}
                        </option>
                      ))}
                  </select>
                )}
              </div>
            ))}

<button
  type="submit"
  className="w-full bg-[#e6b800] text-white py-3 px-6 rounded-lg mt-4 hover:bg-[#c19e00] focus:outline-none focus:ring-2 focus:ring-[#e6b800] disabled:opacity-50 disabled:cursor-not-allowed"
  disabled={isSubmitting}
>
  {isSubmitting ? (
    <span className="flex items-center justify-center">
      <svg
        className="animate-spin h-5 w-5 mr-2 text-white"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        ></circle>
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
        ></path>
      </svg>
      Submitting...
    </span>
  ) : (
    "Submit"
  )}
</button>

          </form>
        )}
      </div>
    </div>
  );
};

export default WorkerApplication;
